// @ts-ignore
import bg from './assets/receive-on-app.webp';
import React, {useMemo} from 'react';
import {useSequentialModalContext} from '@basicComponents/sequential-modal/context';
import {downloadApk, cn, toPriceStr} from '@utils';
import CloseIcon from '@businessComponents/down-app-modal/close';
// @ts-ignore
import button from '@businessComponents/down-app-modal/assets/button.webp';
// import {getReward} from '@/common-pages/luckyspin/luckyspin.service';
import {getDownloadRewardConfig} from '@/pages/home/home.service';
import {getVipConfigListV2} from '@/common-pages/vip/vip.service';
import {getCurrentVip} from '@utils/vip';
import {useLogin} from '@utils/state-hooks';
import {useRequest} from 'ahooks';

export const DOWNLOAD_NO_REWARDED = 'DOWNLOAD_NO_REWARDED';
// 未领取过 并且在h5页面
type NoRewardProps = {
  amount: number;
};
export default function NoReward(props: NoRewardProps) {
  const {amount = 0} = props;
  const login = useLogin();
  // const vip = globalStore.userInfo;
  const {goToNext} = useSequentialModalContext();
  // const [config, setConfig] = useState<any>({});
  const {data = []} = useRequest(getVipConfigListV2, {
    ready: login,
  });
  const {data: rewardConfig} = useRequest(getDownloadRewardConfig, {
    ready: login,
  });
  const vip = useMemo(() => {
    if (!data) return {};
    if (data && data.length === 0) {
      return {};
    }
    // return 0;
    const {currentVip} = getCurrentVip(data);
    return currentVip || {};
  }, [data]);
  const bonus = useMemo(() => {
    if (rewardConfig) {
      const bonusRatio = new Map([
        [0, rewardConfig.lowVipBonusRatio],
        [1, rewardConfig.lowVipBonusRatio],
        [2, rewardConfig.lowVipBonusRatio],
        [3, rewardConfig.lowVipBonusRatio],
        [4, rewardConfig.lowVipBonusRatio],
        [5, rewardConfig.midVipBonusRatio],
        [6, rewardConfig.midVipBonusRatio],
        [7, rewardConfig.midVipBonusRatio],
        [8, rewardConfig.highVipBonusRatio],
        [9, rewardConfig.highVipBonusRatio],
        [10, rewardConfig.highVipBonusRatio],
        [11, rewardConfig.highVipBonusRatio],
        [12, rewardConfig.highVipBonusRatio],
        [13, rewardConfig.highVipBonusRatio],
        [14, rewardConfig.highVipBonusRatio],
        [15, rewardConfig.highVipBonusRatio],
      ]);
      return bonusRatio.get(vip.level || 0);
    }
    return 0;
  }, [rewardConfig, vip]);

  const textbase =
    'text-center text-lg font-bold text-shadow-[0_-1px_0_#FBFF00] bg-gradient-to-b from-[#F24B02] from-[26.67%] to-[#9E3000] to-[73.33%] bg-clip-text text-transparent -tracking-[1px]';
  return (
    <div className="relative">
      <div className="text-white text-[1.375rem] font-extrabold -tracking-[1px] text-center">
        Receive rewards <span className="text-[#FE0] text-2xl">on the App</span>
      </div>
      <div
        className="w-[18.3125rem] h-[16.4375rem] bg-full relative mt-9"
        onClick={() => {
          downloadApk();
          goToNext();
        }}
        style={{
          backgroundImage: `url(${bg})`,
        }}>
        <div className="text-[#F6FF00] text-xs font-bold w-[6.55rem] h-4 absolute left-2.5 top-[6.8125rem] rotate-[350deg]">
          VIP bonus: +{bonus}%
        </div>
        <div className={cn(textbase, 'absolute top-[8.25rem] left-[2.875rem]')}>
          Amount
          <span className="font-extrabold text-[2.125rem]">
            {toPriceStr(amount, {
              fixed: 0,
              round: 'floor',
            })}
          </span>
        </div>
        <div className="absolute left-[8.5rem] bottom-[3rem]">
          <div className={cn(textbase, 'text-sm font-bold uppercase')}>
            Current VIP{vip.level || 0}
          </div>
          <div className={cn(textbase, 'text-sm font-extrabold uppercase ')}>
            gets bonus: +{bonus}%
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center">
        <div
          className="w-[15.3125rem] h-[2.9375rem] bg-full flex justify-center items-center font-bold text-white text-xl"
          onClick={() => {
            downloadApk();
            goToNext();
          }}
          style={{
            backgroundImage: `url(${button})`,
          }}>
          Get It Now
        </div>
      </div>
      <div className="flex items-center justify-center mt-6">
        <div
          className="border border-white rounded-full flex items-center justify-center size-8 cursor-pointer"
          onClick={goToNext}>
          <CloseIcon class="size-2.5" />
        </div>
      </div>
    </div>
  );
}
